export const podcastValue = {
  name: '',
  tags: '',
  audioUiid: '',
  imgUiid: '',
  listenCountDefault: '',
}
